import { ApiError } from '@wyn/contracts';
import { Callout } from './ui.tsx';

export function ErrorNotice({ error }: { error: unknown }) {
  if (!error) return null;
  const msg = error instanceof ApiError ? error.message : error instanceof Error ? error.message : 'Something went wrong.';
  return <Callout tone="bad" role="alert" className="text-blood">{msg}</Callout>;
}
